export const MANUAL = 1138;
export const AUTOMATIC = 1139;
export const SEMI_AUTOMATIC = 1140;
export const DUPLEX = 1141;
